import { css, makeStyles } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  container: ({ colors, spacing }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: calc(100vh - 80px);
    padding: 0 ${spacing.xs};
    background: linear-gradient(
      252.46deg,
      ${colors.brand.primary[300]} 0%,
      ${colors.brand.primary[500]} 100%
    );
    background-size: 400% 400%;
    animation: gradient 10s ease infinite;

    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
  `,
  tzContainer: ({ colors, spacing, fontSizes, grid }) => css`
    bottom: ${spacing.md};
    position: fixed;
    margin: 0 ${spacing.xs} 0 ${spacing.xs};

    div {
      color: ${colors.neutral[200]};
    }
    p {
      font-size: ${fontSizes.xs};
      color: ${colors.background.white};
      margin-top: ${spacing.xxs};
      @media screen and (max-width: ${grid.breakpoint.md}) {
        text-align: center;
      }
    }
  `,
})

export { useStyles }
